module.exports = {"pt-BR":{"realEstate":{"components":{"attendantField":{"notifications":{"fetch":{"failure":"Falha ao buscar atendentes"}}}}}}}